module.exports = __webpack_public_path__ + "static/26-30d1d463a245044a2f82808825d06e03.jpg";